import * as React from 'react';
import classnames from 'classnames';

import type { ProgressBarItem } from 'types';

type Props = {
  start: ProgressBarItem,
  end: ProgressBarItem
};

class ProgressBar extends React.PureComponent<Props> {
  getProgress(): number {
    const { start, end } = this.props;
    const startValue = start?.value || 0;
    const endValue = end?.value || 0;

    if (!endValue) {
      return 0;
    }

    return (startValue / endValue) * 100;
  }

  getProgressPercentage(value: number): number {
    if (value < 100) {
      return Math.trunc(value);
    }
    return 100;
  }

  render(): React.ReactNode {
    const { start, end } = this.props;
    const progress = this.getProgress();
    const startLabelClasses = classnames({
      'progress-bar__label': true,
      'progress-bar__label--bold': start.label.isBold
    });
    const endLabelClasses = classnames({
      'progress-bar__label': true,
      'progress-bar__label--bold': end.label.isBold
    });
    const progressClasses = classnames({
      'progress-bar': true,
      'progress-bar__highlight': true,
      'progress-bar__highlight--color-active': progress <= 100,
      'progress-bar__highlight--color-danger': progress > 100
    });

    return (
      <div className="progress-bar__wrapper">
        <div className="progress-bar__header">
          <span className={startLabelClasses}>
            {start.label.text}
          </span>
          <span className={endLabelClasses}>
            {end.label.text}
          </span>
        </div>
        <div className="progress-bar__line">
          <div className="progress-bar progress-bar__default" />
          <div
            className={progressClasses}
            style={{
              width: `${this.getProgressPercentage(progress)}%`
            }}
          />
        </div>
      </div>
    );
  }
}

export default ProgressBar;
